import { dueDiligenceItems, hoaDueDiligenceItem, sellerDisclosuresDueDiligenceItem } from './navItems';
import { SubNavItem } from './NavPrimitives';

import { usePropertiesContext } from '@/context/PropertiesProvider';
import { useDocumentRecords } from '@/hooks/useDocumentRecords';
import { useHOAChecklist } from '@/hooks/useHOAChecklist';
import { hasProcessedSellerDisclosures } from '@/utils/sellerDisclosureDocuments';

/**
 * dueDiligenceItems plus the HOA and Seller Disclosures tabs, each spliced in
 * right after "The Area" only when the selected property actually has that
 * data — most properties don't, so the static array stays lean by default.
 */
export function useDueDiligenceNavItems(): SubNavItem[] {
  const { selectedProperty } = usePropertiesContext();
  const propertyId = selectedProperty?.property.id;
  const { data: hoaData } = useHOAChecklist(propertyId);
  const { documentRecords } = useDocumentRecords(propertyId);

  const hasSellerDisclosures = hasProcessedSellerDisclosures(documentRecords);

  const itemsToInsert = [
    ...(hasSellerDisclosures ? [sellerDisclosuresDueDiligenceItem] : []),
    ...(hoaData ? [hoaDueDiligenceItem] : []),
  ];
  if (itemsToInsert.length === 0) return dueDiligenceItems;

  const contextScoreIndex = dueDiligenceItems.findIndex(
    (item) => item.path === '/dashboard/context-score',
  );
  const insertAt = contextScoreIndex === -1 ? dueDiligenceItems.length : contextScoreIndex + 1;

  return [
    ...dueDiligenceItems.slice(0, insertAt),
    ...itemsToInsert,
    ...dueDiligenceItems.slice(insertAt),
  ];
}
